export const surrender = [
  // 退保登记
  {
    path: '/surrender-register',
    name: 'SurrenderRegister',
    component: () => import('@/views/surrender/register'),
    meta: {
      title: '退保登记'
    }
  },
  {
    path: '/surrender-success',
    name: 'SurrenderSuccess',
    component: () => import('@/views/surrender/success'),
    meta: {
      title: '退保登记'
    }
  }
]
